import { ActionReducerMap } from '@ngrx/store';
import * as reducers from './reducers';
export interface AppState {
  layout: reducers.LayoutState;
}

export const appReduces: ActionReducerMap<AppState> = {
  layout: reducers.layoutReducer,
};
